/**
 * Resolve a dot-path against an object. Returns `undefined` if any segment is
 * missing or the value at the path is not present.
 */
export const getByPath = (source: unknown, path: string): unknown => {
  if (source === null || source === undefined) return undefined;
  const segments = path.split('.');
  let current: unknown = source;
  for (const segment of segments) {
    if (current === null || current === undefined) return undefined;
    if (typeof current !== 'object') return undefined;
    current = (current as Record<string, unknown>)[segment];
  }
  return current;
};
